/* ============================================================
   INDUS GOTHIC — forge.js  (Shopify build)
   Real Shopify Cart AJAX API wired into the Forge cart drawer,
   plus mobile nav, predictive search, and all PDP interactions.
   Config is read from window.IG (set in layout/theme.liquid).
   ============================================================ */
(function () {
  'use strict';

  var IG = window.IG || {};
  var FREE_SHIP = (IG.freeShipping != null) ? IG.freeShipping : 0; // in cents, 0 = disabled
  var ROUTES = IG.routes || {};
  var CART_ADD = (ROUTES.cart_add_url || '/cart/add') + '.js';
  var CART_CHANGE = (ROUTES.cart_change_url || '/cart/change') + '.js';
  var CART_URL = (ROUTES.cart_url || '/cart') + '.js';
  var PREDICTIVE = (ROUTES.predictive_search_url || '/search/suggest') + '.json';
  var SEARCH_URL = ROUTES.search_url || '/search';

  /* ---------- money ---------- */
  function formatMoney(cents, fmt) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    fmt = fmt || IG.moneyFormat || '${{amount}}';
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(n, d) { return (typeof n === 'undefined' || n === null) ? d : n; }
    function thousands(num, precision, thousandsSep, decimalSep) {
      precision = defaultTo(precision, 2);
      thousandsSep = defaultTo(thousandsSep, ',');
      decimalSep = defaultTo(decimalSep, '.');
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandsSep);
      var cents = parts[1] ? decimalSep + parts[1] : '';
      return dollars + cents;
    }
    var match = fmt.match(placeholderRegex);
    var fmtType = match ? match[1] : 'amount';
    switch (fmtType) {
      case 'amount': value = thousands(cents, 2); break;
      case 'amount_no_decimals': value = thousands(cents, 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = thousands(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(cents, 0, ' '); break;
      case 'amount_with_apostrophe_separator': value = thousands(cents, 2, "'", '.'); break;
      default: value = thousands(cents, 2);
    }
    return fmt.replace(placeholderRegex, value);
  }
  window.IG_formatMoney = formatMoney;

  /* ---------- toast ---------- */
  var toastEl = document.createElement('div');
  toastEl.className = 'toast';
  document.body.appendChild(toastEl);
  var tt;
  function toast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(tt);
    tt = setTimeout(function () { toastEl.classList.remove('show'); }, 2000);
  }

  /* ---------- cart drawer chrome (injected) ---------- */
  var scrim = document.createElement('div');
  scrim.className = 'scrim';
  document.body.appendChild(scrim);

  var drawer = document.createElement('aside');
  drawer.className = 'drawer';
  drawer.setAttribute('aria-label', 'Cart');
  drawer.setAttribute('aria-hidden', 'true');
  drawer.innerHTML =
    '<div class="d-head"><div><h3 style="display:inline-block">Your bag</h3><span class="ct" id="ig-ct"></span></div>' +
    '<button class="d-close" aria-label="Close cart">✕</button></div>' +
    '<div class="ship" id="ig-ship"></div>' +
    '<div class="items" id="ig-items"></div>' +
    '<div class="foot" id="ig-foot"></div>';
  document.body.appendChild(drawer);

  var itemsEl = drawer.querySelector('#ig-items');
  var footEl = drawer.querySelector('#ig-foot');
  var shipEl = drawer.querySelector('#ig-ship');
  var ctEl = drawer.querySelector('#ig-ct');

  function escapeHtml(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- render from a Shopify cart object ---------- */
  function renderCart(cart) {
    var c = cart.item_count || 0;
    document.querySelectorAll('.cart-count').forEach(function (b) {
      b.textContent = c;
      b.setAttribute('data-empty', c === 0 ? '1' : '0');
    });
    ctEl.textContent = c === 1 ? '1 item' : c + ' items';

    var sub = cart.total_price || 0; // cents

    // free-ship progress
    if (FREE_SHIP > 0) {
      if (sub >= FREE_SHIP) {
        shipEl.innerHTML = '<div class="lbl">✓ You’ve unlocked <b>free shipping</b></div>' +
          '<div class="bar"><i style="width:100%"></i></div>';
      } else {
        var pct = sub === 0 ? 0 : Math.min(100, Math.round((sub / FREE_SHIP) * 100));
        var remain = FREE_SHIP - sub;
        shipEl.innerHTML = '<div class="lbl"><b>' + formatMoney(remain) + '</b> away from free shipping</div>' +
          '<div class="bar"><i style="width:' + pct + '%"></i></div>';
      }
      shipEl.style.display = '';
    } else {
      shipEl.style.display = 'none';
    }

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<div class="empty"><div class="em-ic">◇</div>Your bag is empty.<br/>Original art awaits.</div>';
      footEl.innerHTML = '<a class="btn btn-out btn-block" href="' + (ROUTES.all_products || '/collections/all') + '">Browse the collection</a>';
      return;
    }

    var html = '';
    cart.items.forEach(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_140x$1$2') : '';
      var variantLabel = (it.options_with_values || []).map(function (o) { return escapeHtml(o.value); }).join(' · ');
      if (!variantLabel && it.variant_title) variantLabel = escapeHtml(it.variant_title);
      var props = '';
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          if (k.charAt(0) === '_' || !it.properties[k]) return;
          props += '<small>' + escapeHtml(k) + ': ' + escapeHtml(it.properties[k]) + '</small>';
        });
      }
      html +=
        '<div class="line" data-key="' + it.key + '">' +
          '<a class="th" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="' + escapeHtml(it.product_title) + '"/>' : '') + '</a>' +
          '<div class="li-mid"><a class="nm" href="' + it.url + '" style="color:inherit">' + escapeHtml(it.product_title) + '</a>' +
            '<div class="vr">' + (variantLabel || '') + props + '</div>' +
            '<div class="qty" data-key="' + it.key + '"><button class="dec" aria-label="decrease">−</button>' +
              '<span>' + it.quantity + '</span><button class="inc" aria-label="increase">+</button></div>' +
          '</div>' +
          '<div class="li-end"><div class="lp">' + formatMoney(it.final_line_price) + '</div>' +
            '<button class="rm" data-key="' + it.key + '">Remove</button></div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;

    var shipNote = FREE_SHIP > 0 && sub >= FREE_SHIP ? 'Free' : 'Calculated at checkout';
    footEl.innerHTML =
      '<div class="row"><span>Subtotal</span><span>' + formatMoney(sub) + '</span></div>' +
      '<div class="row"><span>Shipping</span><span>' + shipNote + '</span></div>' +
      '<div class="row total"><span>Total</span><b>' + formatMoney(sub) + '</b></div>' +
      '<button class="btn btn-orange btn-block js-checkout" type="button">Checkout</button>' +
      '<div class="note">Taxes calculated at checkout · 30-day returns</div>';
  }

  /* ---------- cart API ---------- */
  function fetchCart() {
    return fetch(CART_URL, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(payload) {
    drawer.setAttribute('aria-busy', 'true');
    return fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { throw data; }
        return data;
      });
    }).then(function (item) {
      return fetchCart().then(function () {
        toast((item.product_title || 'Item') + ' added to bag');
        openDrawer();
      });
    }).catch(function (err) {
      toast((err && err.description) ? err.description : 'Could not add to bag');
    }).finally(function () {
      drawer.removeAttribute('aria-busy');
    });
  }

  function changeLine(key, qty) {
    drawer.setAttribute('aria-busy', 'true');
    return fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .finally(function () { drawer.removeAttribute('aria-busy'); });
  }

  /* ---------- open / close ---------- */
  function openDrawer() {
    scrim.classList.add('show'); drawer.classList.add('show');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    scrim.classList.remove('show'); drawer.classList.remove('show');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  scrim.addEventListener('click', closeDrawer);
  drawer.querySelector('.d-close').addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('.cart-btn, .js-cart-open');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }

    var add = e.target.closest('[data-add]');
    if (add && !add.disabled) {
      e.preventDefault();
      var variantId = currentVariantId(add);
      if (!variantId) { toast('Select a size first'); return; }
      var qty = 1;
      if (add.hasAttribute('data-use-form')) {
        var q = document.getElementById('pdp-qty');
        if (q) qty = Math.max(1, parseInt(q.value, 10) || 1);
      } else if (add.getAttribute('data-qty')) {
        qty = Math.max(1, parseInt(add.getAttribute('data-qty'), 10) || 1);
      }
      addToCart({ items: [{ id: variantId, quantity: qty }] });
      return;
    }

    if (e.target.closest('.js-checkout')) {
      e.preventDefault();
      window.location.href = '/checkout';
      return;
    }
  });

  // variant resolution: PDP form (selected size button) or data-variant-id on the button itself
  function currentVariantId(btn) {
    if (btn.hasAttribute('data-use-form')) {
      var sel = document.querySelector('.sizes button[aria-pressed="true"]:not([disabled])');
      if (sel && sel.getAttribute('data-variant-id')) return sel.getAttribute('data-variant-id');
      var hidden = document.getElementById('pdp-variant-id');
      if (hidden && hidden.value) return hidden.value;
    }
    return btn.getAttribute('data-variant-id') || null;
  }

  // qty steppers + remove inside drawer
  drawer.addEventListener('click', function (e) {
    var inc = e.target.closest('.qty .inc'), dec = e.target.closest('.qty .dec'), rm = e.target.closest('.rm');
    if (inc || dec) {
      var wrap = (inc || dec).closest('.qty');
      var key = wrap.dataset.key;
      var current = parseInt(wrap.querySelector('span').textContent, 10) || 1;
      changeLine(key, inc ? current + 1 : Math.max(0, current - 1));
    } else if (rm) {
      changeLine(rm.dataset.key, 0);
    }
  });

  /* ---------- PDP: size picker updates price + variant ---------- */
  document.addEventListener('click', function (e) {
    var sb = e.target.closest('.sizes button');
    if (!sb || sb.disabled) return;
    var group = sb.parentElement;
    group.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    sb.setAttribute('aria-pressed', 'true');
    // sync hidden field + price + add button label
    var vid = sb.getAttribute('data-variant-id');
    var hidden = document.getElementById('pdp-variant-id');
    if (hidden && vid) hidden.value = vid;
    var priceEl = document.querySelector('.buy .price');
    if (priceEl && sb.getAttribute('data-price')) {
      priceEl.innerHTML = formatMoney(parseInt(sb.getAttribute('data-price'), 10));
    }
    var addBtn = document.querySelector('.buy [data-add]');
    if (addBtn) {
      var avail = sb.getAttribute('data-available') !== 'false';
      addBtn.disabled = !avail;
      addBtn.textContent = avail
        ? 'Add to cart · ' + formatMoney(parseInt(sb.getAttribute('data-price'), 10))
        : 'Sold out';
    }
    var barAdd = document.querySelector('.pdp-bar [data-add]');
    if (barAdd && vid) barAdd.setAttribute('data-variant-id', vid);
  });

  /* ---------- PDP: qty stepper ---------- */
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('.qstep .dec'), inc = e.target.closest('.qstep .inc');
    if (!dec && !inc) return;
    var input = document.getElementById('pdp-qty');
    if (!input) return;
    var v = Math.max(1, parseInt(input.value, 10) || 1);
    input.value = inc ? v + 1 : Math.max(1, v - 1);
  });

  /* ---------- PDP: accordion ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.acc .q');
    if (!q) return;
    var item = q.closest('.item');
    item.classList.toggle('open');
    var pm = q.querySelector('.pm');
    if (pm) pm.textContent = item.classList.contains('open') ? '–' : '+';
  });

  /* ---------- PDP: gallery thumbs ---------- */
  document.addEventListener('click', function (e) {
    var tb = e.target.closest('.gallery .thumbs button');
    if (!tb) return;
    var main = document.querySelector('.gallery .stage .frame img');
    var full = tb.getAttribute('data-full') || (tb.querySelector('img') && tb.querySelector('img').src);
    if (main && full) { main.src = full; if (tb.querySelector('img')) main.alt = tb.querySelector('img').alt; }
    document.querySelectorAll('.gallery .thumbs button').forEach(function (b) { b.classList.remove('active'); });
    tb.classList.add('active');
  });

  /* ---------- header search modal + predictive ---------- */
  (function () {
    var trigger = document.querySelector('.js-search-open, .icon-btn[title="Search"]');
    if (!trigger) return;
    var modal = document.createElement('div');
    modal.className = 'search-modal';
    modal.innerHTML =
      '<div class="sm-scrim"></div>' +
      '<div class="sm-panel"><button class="sm-close" aria-label="Close search">✕</button><div class="sm-inner">' +
        '<form class="search-form" action="' + SEARCH_URL + '" method="get" role="search">' +
          '<input type="search" name="q" placeholder="Search the collection…" autocomplete="off" aria-label="Search"/>' +
          '<button type="submit">Search</button></form>' +
        '<div class="predictive" id="ig-predictive"></div>' +
      '</div></div>';
    document.body.appendChild(modal);
    var input = modal.querySelector('input[name="q"]');
    var results = modal.querySelector('#ig-predictive');

    function open() { modal.classList.add('show'); document.body.style.overflow = 'hidden'; setTimeout(function () { input.focus(); }, 60); }
    function close() { modal.classList.remove('show'); document.body.style.overflow = ''; }
    trigger.style.cursor = 'pointer';
    trigger.addEventListener('click', function (e) { e.preventDefault(); open(); });
    modal.querySelector('.sm-scrim').addEventListener('click', close);
    modal.querySelector('.sm-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var deb;
    input.addEventListener('input', function () {
      clearTimeout(deb);
      var q = input.value.trim();
      if (q.length < 2) { results.classList.remove('show'); results.innerHTML = ''; return; }
      deb = setTimeout(function () {
        var url = PREDICTIVE + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<div class="ph">No matches</div>';
            } else {
              var h = '<div class="ph">Products</div>';
              products.forEach(function (p) {
                var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
                h += '<a class="pr-item" href="' + p.url + '">' +
                  '<div class="th">' + (img ? '<img src="' + img + '" alt=""/>' : '') + '</div>' +
                  '<div><div class="nm">' + escapeHtml(p.title) + '</div>' +
                  '<div class="pr2">' + (p.price ? formatMoney(p.price) : '') + '</div></div></a>';
              });
              results.innerHTML = h;
            }
            results.classList.add('show');
          })
          .catch(function () { results.classList.remove('show'); });
      }, 220);
    });
  })();

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var yr = document.getElementById('yr'); if (yr) yr.textContent = new Date().getFullYear();
    fetchCart();
    if (location.hash === '#cart') setTimeout(openDrawer, 350);
  });
})();

/* ============================================================
   MOBILE NAV — hamburger + left slide-in drawer.
   Clones the header's own primary links so active state + the
   per-page link set carry over automatically.
   ============================================================ */
(function () {
  var header = document.querySelector('header .nav');
  if (!header) return;

  var burger = document.createElement('button');
  burger.className = 'menu-btn';
  burger.setAttribute('aria-label', 'Open menu');
  burger.setAttribute('aria-expanded', 'false');
  burger.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M3 6h18M3 12h18M3 18h18"/></svg>';
  header.insertBefore(burger, header.firstChild);

  var srcLinks = document.querySelectorAll('header nav.links a');
  var linksHtml = '';
  srcLinks.forEach(function (a, i) {
    var active = a.classList.contains('active') ? ' active' : '';
    var n = ('0' + (i + 1)).slice(-2);
    linksHtml += '<a class="' + active.trim() + '" href="' + a.getAttribute('href') + '">' +
      '<span class="tt">' + a.textContent.trim() + '</span><span class="ix">' + n + '</span></a>';
  });

  var brand = document.querySelector('header .brand');
  var brandHtml = brand ? brand.outerHTML : '<span class="brand"><b>Indus Gothic</b></span>';

  var navScrim = document.createElement('div');
  navScrim.className = 'nav-scrim';
  document.body.appendChild(navScrim);

  var nav = document.createElement('aside');
  nav.className = 'nav-drawer';
  nav.setAttribute('aria-label', 'Menu');
  nav.innerHTML =
    '<div class="nd-head">' + brandHtml +
      '<button class="nd-close" aria-label="Close menu">✕</button></div>' +
    '<nav class="nd-links">' + linksHtml + '</nav>' +
    (window.IG_SUBLINKS || '') +
    '<div class="nd-foot">' +
      '<button class="btn btn-orange js-cart-open" type="button">View your bag</button>' +
      '<div class="nd-tag">◆ Drawn by hand, never AI</div></div>';
  document.body.appendChild(nav);

  function openNav() { navScrim.classList.add('show'); nav.classList.add('show'); document.body.style.overflow = 'hidden'; burger.setAttribute('aria-expanded', 'true'); }
  function closeNav() { navScrim.classList.remove('show'); nav.classList.remove('show'); document.body.style.overflow = ''; burger.setAttribute('aria-expanded', 'false'); }

  burger.addEventListener('click', openNav);
  navScrim.addEventListener('click', closeNav);
  nav.querySelector('.nd-close').addEventListener('click', closeNav);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });
  nav.querySelector('.js-cart-open').addEventListener('click', closeNav);

  /* sticky add-to-cart bar on the product page (phones) */
  var buy = document.querySelector('.buy');
  var pdpAdd = buy && buy.querySelector('[data-add]');
  if (buy && pdpAdd) {
    var nm = pdpAdd.getAttribute('data-name') || (document.querySelector('.buy h1') || {}).textContent || '';
    var pr = pdpAdd.getAttribute('data-price') || '';
    var bar = document.createElement('div');
    bar.className = 'pdp-bar';
    bar.innerHTML =
      '<div class="pb-info"><div class="pb-nm">' + nm + '</div><div class="pb-pr">' +
        (pr ? (window.IG_formatMoney ? window.IG_formatMoney(parseInt(pr, 10)) : pr) : '') + '</div></div>' +
      '<button class="btn btn-orange pb-add" type="button" data-add data-use-form' +
        ' data-variant-id="' + (pdpAdd.getAttribute('data-variant-id') || '') + '">Add to cart</button>';
    document.body.appendChild(bar);
    document.body.classList.add('has-pdp-bar');
  }
})();
